"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var PropTypes = require("prop-types");

var defaultI18next = require("i18next");

var _a = React.createContext({
  i18n: defaultI18next.init(),
  locale: null
}),
    Consumer = _a.Consumer,
    Provider = _a.Provider;

exports.I18NextConsumer = Consumer;

var I18NextProvider =
/** @class */
function (_super) {
  __extends(I18NextProvider, _super);

  function I18NextProvider() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      locale: null // language selection is async, while is not initislized set to null

    };

    _this.handleLanguageChange = function (language) {
      _this.setState({
        locale: language
      });
    };

    return _this;
  }

  I18NextProvider.prototype.componentDidMount = function () {
    var i18n = this.props.i18n;

    if (!i18n) {
      console.error('Seems you have not pass the i18n object to the global I18NextProviderProvider');
      return;
    }

    i18n.on("languageChanged", this.handleLanguageChange);
  };

  I18NextProvider.prototype.componentWillUnmount = function () {
    this.props.i18n.off('languageChanged', this.handleLanguageChange);
  };

  I18NextProvider.prototype.render = function () {
    var locale = this.state.locale;
    var _a = this.props,
        i18n = _a.i18n,
        children = _a.children;
    return React.createElement(Provider, {
      value: {
        i18n: i18n,
        locale: locale
      }
    }, " ", children, " ");
  };

  I18NextProvider.propTypes = {
    i18n: PropTypes.object.isRequired
  };
  return I18NextProvider;
}(React.Component);

exports.default = I18NextProvider;